import { ServiceLogsError } from '@/service/logErrors/serviceLogErros'

const serviceLogErrors = new ServiceLogsError()

export default {
  namespace: true,
  state: {
    filters: {
      branch: [
        { title: 'master', icon: 'GitBranchIcon' },
        { title: 'developer', icon: 'GitBranchIcon' },
        { title: 'Developer_Emerson', icon: 'GitBranchIcon' },
      ],
      status: [
        { title: 'resolvido', icon: 'CheckCircleIcon' },
        { title: 'em aberto', icon: 'UnlockIcon' },
        { title: 'em correção', icon: 'SettingsIcon' },
        { title: 'reaberto', icon: 'RepeatIcon' },
      ],
      httpStatusCode: [{
        title: '200', icon: 'HardDriveIcon',
      }, {
        title: '201', icon: 'HardDriveIcon',
      }, {
        title: '400', icon: 'HardDriveIcon',
      }, {
        title: '401', icon: 'HardDriveIcon',
      }, {
        title: '403', icon: 'HardDriveIcon',
      }, {
        title: '404', icon: 'HardDriveIcon',
      }, {
        title: '500', icon: 'HardDriveIcon',
      }, {
        title: '502', icon: 'HardDriveIcon',
      }, {
        title: '503', icon: 'HardDriveIcon',
      }, {
        title: '504', icon: 'HardDriveIcon',
      }],
    },
    filtersSelected: {},
    listLogErrrors: [],
    meta: {
      total: 0,
      page: 1,
      perPage: 10,
    },
  },
  getters: {
    getFilters: state => state.filters,
    getListLogErrrors: state => state.listLogErrrors,
    getMeta: state => state.meta,
  },
  mutations: {
    setFilters(state, filters) {
      if (filters.branchArray) {
        const branchTitles = state.filters.branch.map(branch => branch.title)

        filters.branchArray.forEach(branch => {
          if (!branchTitles.includes(branch.title)) {
            state.filters.branch.push(branch)
            branchTitles.push(branch.title)
          }
        })
      }
      if (filters.statusArray) {
        const statusTitles = state.filters.status.map(status => status.title)

        filters.statusArray.forEach(status => {
          if (!statusTitles.includes(status.title)) {
            state.filters.status.push(status)
            statusTitles.push(status.title)
          }
        })
      }
      if (filters.statusCodeArray) {
        const statusCodeTitles = state.filters.httpStatusCode.map(statusCode => statusCode.title)

        filters.statusCodeArray.forEach(statusCode => {
          if (!statusCodeTitles.includes(statusCode.title)) {
            state.filters.httpStatusCode.push(statusCode)
            statusCodeTitles.push(statusCode.title)
          }
        })
      }
    },
    setListLogErrrors(state, listLogErrrors) {
      state.listLogErrrors = listLogErrrors
    },
    setMeta(state, meta) {
      state.meta = meta
    },
    setFiltersSelected(state, filtersSelected) {
      const keys = Object.keys(filtersSelected)

      keys.forEach(key => {
        if (filtersSelected[key] === null) {
          delete state.filtersSelected[key]
        } else if (filtersSelected[key] === '') {
          delete state.filtersSelected[key]
        } else if (Array.isArray(filtersSelected[key])) {
          if (!state.filtersSelected[key]) {
            state.filtersSelected[key] = []
          }
          filtersSelected[key].forEach(item => {
            if (!state.filtersSelected[key].includes(item)) {
              state.filtersSelected[key].push(item)
            }
          })
        } else {
          state.filtersSelected[key] = filtersSelected[key]
        }
      })
    },
    setFiltersClear(state) {
      state.filtersSelected = {}
    },
  },
  actions: {
    async getFilters({ commit, state }) {
      try {
        const filters = await serviceLogErrors.getErros(state.filtersSelected)
        commit('setFilters', filters)
        commit('setListLogErrrors', filters.data)
        commit('setMeta', filters.meta)
      } catch (error) {
        console.error(error)
      }
    },
  },
}
